import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const LocationInsightsSkeleton = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Header Skeleton */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Skeleton variant="circular" width={60} height={60} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={28} />
          <Skeleton variant="text" width="70%" height={20} />
        </Box>
      </Box>

      {/* Search Filter Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 2 }} />
      </Box>

      {/* Country Wise Users Chart Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width="30%" height={24} />
        <Skeleton variant="text" width="15%" height={20} />
        <Skeleton variant="rectangular" width="100%" height={250} sx={{ borderRadius: 2 }} />
      </Box>

      {/* State + City Wise Users Skeleton */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[1, 2].map((i) => (
          <Grid item xs={12} md={6} key={i}>
            <Skeleton variant="text" width="50%" height={24} />
            <Skeleton variant="text" width="30%" height={20} />
            <Skeleton variant="rectangular" width="100%" height={220} sx={{ borderRadius: 2 }} />
          </Grid>
        ))}
      </Grid>

      {/* World Map Skeleton */}
      <Box>
        <Skeleton variant="text" width="25%" height={24} />
        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  );
};

export default LocationInsightsSkeleton;
